<template>
  <div class="__surequote-nav">
      <button type="button" class="__surequote-nav__btn" :class="{'disabled': questionNumber === 1, 'active': questionNumber > 1}" :disabled="questionNumber === 1" @click="back()">Back</button>
      <!-- <button type="button" class="__surequote-nav__btn __surequote-nav__btn--green" :class="{'active': questionNumber > 1}" @click="next()">Next</button> -->
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SELECT_NEXT_QUESTION, SELECT_PREV_QUESTION } from '@/store/actions.type';

export default {
  name: 'surequote-navigation',
  computed: {
    ...mapGetters(["questionNumber"])
  },
  methods: {
    next() {
      this.$store.dispatch(SELECT_NEXT_QUESTION);
    },
    back() {
      console.log(this.$router.history.current.name)
      if (this.$router.history.current.name == 'questions')
        this.$store.dispatch(SELECT_PREV_QUESTION);
      else
        this.$router.go(-1);
    }
  }
}
</script>